<template>
  <el-container v-loading="isShowLoading">
    <el-main>
      <div>
        <el-row>
          <el-form :model="filterData" :inline="true" ref="form">
            <el-form-item prop="jkDm">
              <el-input v-model="filterData.jkDm" placeholder="请输入接口代码"></el-input>
            </el-form-item>
            <el-form-item prop="dyqd">
              <el-select v-model="filterData.dyqd" placeholder="请选择调用渠道">
                <el-option value></el-option>
                <el-option label="电脑" value="00"></el-option>
                <el-option label="安卓" value="01"></el-option>
                <el-option label="苹果" value="02"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="jkyyDm">
              <el-select v-model="filterData.jkyyDm" placeholder="请选择接口应用">
                <el-option value></el-option>
                <el-option
                  v-for="item in jkyyOptions"
                  :key="item.jkyyDm"
                  :label="item.jkyyMc"
                  :value="item.jkyyDm"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="jkdlDm">
              <el-select v-model="filterData.jkdlDm" placeholder="请选择接口大类" @change="queryXlOption">
                <el-option lable="--请选择接口大类" value></el-option>
                <el-option
                  v-for="item in dlOptions"
                  :key="item.jkdlDm"
                  :label="item.jkdlMc"
                  :value="item.jkdlDm"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="jkxlDm">
              <el-select v-model="filterData.jkxlDm" placeholder="请选择接口小类">
                <el-option lable="--请选择接口小类" value></el-option>
                <el-option
                  v-for="item in xlOptions"
                  :key="item.jkxlDm"
                  :label="item.jkxlMc"
                  :value="item.jkxlDm"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="czryMc">
              <el-input v-model="filterData.czryMc" placeholder="请输入操作人员名称"></el-input>
            </el-form-item>
            <el-form-item prop="dyzt">
              <el-input v-model="filterData.jkycDm" placeholder="请输入接口异常代码"></el-input>
            </el-form-item>
            <el-form-item label style="width:30%">
              <el-col :span="11">
                <el-form-item prop="dysjQ" style="width:100%;">
                  <el-date-picker
                    type="date"
                    placeholder="选择调用日期起"
                    v-model="filterData.dysjQ"
                    style="width: 100%;"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2" align="center">-</el-col>
              <el-col :span="11">
                <el-form-item prop="dysjZ" style="width:100%;">
                  <el-date-picker
                    placeholder="选择调用日期止"
                    v-model="filterData.dysjZ"
                    style="width: 100%;"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="onFilter">查询</el-button>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="resetForm('form')"
              >清空</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <el-table
            ref="singleTable"
            :data="recordData"
            highlight-current-row
            style="width: 100%"
            :height="tableHeight"
            :header-cell-style="{background:'#f5f7fa', color: 'black'}" border
            :stripe="stripeVisible"
          >
            <el-table-column type="index" label="选择" align="center" width="70"></el-table-column>
            <el-table-column property="dyqd" label="调用渠道" align="center" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.dyqd == '00'">
                  <i class="el-icon-monitor"></i>电脑
                </div>
                <div v-else-if="scope.row.dyqd == '01'">
                  <i class="el-icon-mobile-phone"></i>安卓
                </div>
                <div v-else-if="scope.row.dyqd == '02'">
                  <i class="el-icon-apple"></i>苹果
                </div>
                <div v-else>
                  <i class="el-icon-warning-outline"></i>其他
                </div>
              </template>
            </el-table-column>
            <el-table-column property="jkDm" label="接口代码" align="center" width="200" show-overflow-tooltip="true"></el-table-column>
            <el-table-column property="jkMc" label="接口名称" align="center" width="150" show-overflow-tooltip="true"></el-table-column>
            <el-table-column property="jkyyMc" label="接口应用" align="center" width="80" show-overflow-tooltip="true"></el-table-column>
            <el-table-column property="jkdlMc" label="接口大类" align="center" width="150" show-overflow-tooltip="true"></el-table-column>
            <el-table-column property="jkxlMc" label="接口小类" align="center" width="150" show-overflow-tooltip="true"></el-table-column>
            <el-table-column property="jkycDm" label="异常代码" align="center" width="100"></el-table-column>
            <el-table-column
              property="qqnr"
              label="请求内容"
              align="center"
              width="200"             
            >
             <template slot-scope="scope">
            <div
              class="dt"
              @click="columnDeal(scope.row.qqnr)"
            >
              {{scope.row.qqnr}}
            </div>
          </template>
          </el-table-column>
            <el-table-column property="ipdz" label="ip地址" align="center" width="120"></el-table-column>
            <el-table-column property="czryMc" label="操作人员" align="center" width="100"></el-table-column>
            <el-table-column property="dysj" label="调用时间" align="center" width="155"></el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin: 18px 8px">
          <el-col :span="24">
            <pagination
              v-show="pagination.total/pagination.pageSize>1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
              :page.sync="pagination.page"
              :limit.sync="pagination.pageSize"
              @pagination="onFilter"
            />
          </el-col>
        </el-row>
      </div>
      <div style="height: 60px"></div>
    </el-main>
  </el-container>
</template>

<script>
import _ from "lodash";

let _kits, _table;
export default {
  components: {},
  data() {
    return {
      radio: "",
      tooltipShow: true,
      isShowLoading: true,
      templateSelection: {},
      pageWidth: 600,
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%",
        edit: false
      },
      //数据绑定相关
      filterData: {
        jkDm: "",
        jkMc: "",
        dyqd: "",
        jkyyDm: "",
        jkdlDm: "",
        jkxlDm: "",
        jkycDm: "",
        czryMc: "",
        dysjQ: "",
        dysjZ: ""
      }, //过滤信息
      recordData: [], //展示信息
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }, //分页信息
      dlOptions: [],
      xlOptions: [],
      jkyyOptions: []
    };
  },
  methods: {
    isEmpty(val, defVal) {
      if (_.isEmpty(val)) {
        return _.isEmpty(defVal) ? true : defVal;
      }
      return val;
    },
    onFilter() {
      this.templateSelection = {};
      this.queryJkycjlTable();
    },
    init() {
      // _table.load();
    },
    getCurrentRow(row) {
      console.log("getCurrentRow", row);
      //获取选中数据
      this.templateSelection = row;
    },
    queryJkycjlTable() {
      console.log("queryJkycjlTable");
      let param = Object.assign({}, this.filterData, this.pagination);
      _kits.api.call("QUERYJKYCJL", param, result => {
        if (result.returnCode == "0000") {
          this.isShowLoading = false;
          console.log(
            "queryJkycjlTable",
            "result",
            result.data.total,
            result.data.list
          );
          this.recordData = result.data.list;
          this.pagination.total = Number.parseInt(result.data.total);
        } else {
          this.$message.error(result.returnMsg);
        }
      });

      this.init();
    },
    queryJkyyOption() {
      _kits.api.call("SELECTJKYY", {}, result => {
        if (result.returnCode == "0000") {
          console.log("queryJkyyOption", "result", result);
          // if (result.returnMsg != "") {
          //   this.$message(result.returnMsg);
          // }
          this.jkyyOptions = result.data;
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    queryDlOption() {
      _kits.api.call("SELECTJKDL", {}, result => {
        if (result.returnCode == "0000") {
          console.log("queryDlOption", "result", result);
          // if (result.returnMsg != "") {
          //   this.$message(result.returnMsg);
          // }
          this.dlOptions = result.data;
        } else {
          this.$message.error(result.returnMsg);
        }
      });
    },
    queryXlOption() {
      console.log("queryXlOption", this.filterData.jkdlDm);
      this.filterData.jkxlDm = "";
      if (this.filterData.jkdlDm == "") {
        this.xlOptions = [];
        return;
      }
      _kits.api.call(
        "SELECTJKXL",
        { jkdlDm: this.filterData.jkdlDm },
        result => {
          if (result.returnCode == "0000") {
            console.log("queryXlOption", "result", result);
            // if (result.returnMsg != "") {
            //   this.$message(result.returnMsg);
            // }
            this.xlOptions = result.data;
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    },
    resetForm(formName) {
      console.log("resetForm", formName);
      this.$refs[formName].resetFields();
    },
    columnDeal(data) {
      console.log("columnDeal",data);
        if (data) {
          this.$alert(
            "<span style='word-wrap: break-word;'>" + data + "</span>",
            {
              dangerouslyUseHTMLString: true
            }
          );
        }
    }
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
  },
  computed: {},
  mounted() {
    this.queryJkyyOption();
    this.queryDlOption();
    this.queryJkycjlTable();
  }
};
</script>
<style scoped>
.el-form .el-form-item {
  width: 18%;
}
</style>
